import { Subject } from 'rxjs';
import { useUpdateSessionInfo } from '../../services/system/login-service';

const notifyTrialPurchaseComplete = new Subject<void>();
const notifyTrialPurchaseOptionChange = new Subject<void>();

export const notifyTrialPurchaseCompleteObservable = notifyTrialPurchaseComplete.asObservable();
export const notifyTrialPurchaseOptionChangeObservable = notifyTrialPurchaseOptionChange.asObservable();

export const notifyTrialPurchaseCompleteToComponents = async () => {
    await useUpdateSessionInfo(true);
    notifyTrialPurchaseComplete.next();
};

export const notifyTrialPurchaseOptionChangeToComponents = () => {
    notifyTrialPurchaseOptionChange.next();
    useUpdateSessionInfo(true);
};

export const EVENT_PURCHASE_MESSAGE = 'SubscriptionStatus';
export const EVENT_PURCHASE_STATUS = 'active';
export const EVENT_CONTACT_SALES_MESSAGE = 'ContactSales';
export const EVENT_NAVIGATE_TO_HOME_MESSAGE = 'GoToHome';
